import axios from 'axios'
import { getCookie } from '../../../utils/common';


const token = getCookie('token')
axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT || `${window.location.origin}/`
axios.defaults.headers.common['Authorization'] = token && `Bearer ${token}`
axios.defaults.headers.common['X-Frame-Options'] = "SAMEORIGIN"

export default axios
